module.exports = __webpack_public_path__ + "static/media/opacity.3c8ed0b4.svg";